module.exports = __webpack_public_path__ + "static/media/pimg_default_en.d8bf011e.jpg";